// @flow

import React, { Fragment } from 'react';

import { urlWithNext } from '@zapier/url-utils';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import Link from 'app/common/components/Link';
import help from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Help';
import topic from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Topic';
import { getDefaultFields } from 'app/developer-v3/components/PartnerSupportForm/content/nodes/common';

import noAppYetChild from './noAppYet';

const developerPlatform = topic({
  zendeskCustomFieldId: 360044601391, // You may need to update this ID
  label: 'What do you need help with?',
  items: [
    {
      value: 'existing',
      icon: 'miscBolt',
      label: 'Help with an existing integration',
      zendeskCustomFieldValue: 'pcf-existing',
      child: help({
        docs: {
          title: 'Log in to contact Support about a specific integration',
          body: () => (
            <Fragment>
              <p>
                For troubleshooting a specific App, please{' '}
                <Link
                  href={urlWithNext(
                    `${ZAPIER_APP_BASE_URL}/app/login`,
                    window.location.href
                  )}
                >
                  log in
                </Link>
                . For general assistance for troubleshooting Apps, check out our{' '}
                <Link href={`${BASE_DOC_URL_VB}/quickstart/how-zapier-works`}>
                  Developer Documentation
                </Link>
                .
              </p>
            </Fragment>
          ),
        },
        contact: getDefaultFields(false),
      }),
    },
    {
      value: 'building',
      icon: 'personCircleFill',
      label: 'Help with a new integration',
      zendeskCustomFieldValue: 'pcf-new',
      child: noAppYetChild,
    },
  ],
});

export default developerPlatform;
